import PropTypes from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';

const prefix = 'ORDER_HISTORY';
const createAction = createPrefixedActionFactory(prefix);

export const mergeExistingOrder = createAction({
  type: 'MERGE_EXISTING_ORDER',
  propTypes: {
    orderItems: PropTypes.array,
  },
});

export const cancelMergeOrder = createAction({
  type: 'CANCEL_MERGE_ORDER',
});

export const continueWithoutUnavailableDishes = createAction({
  type: 'CONTINUE_WITHOUT_UNAVAILABLE_DISHES',
});

export const setUnavailableItems = createAction({
  type: 'SET_UNAVAILABLE_ITEMS',
  propTypes: {
    items: PropTypes.array.isRequired,
  },
});
